import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {API} from '../../config/api';


@Injectable()
export class SchoolReportService {

  constructor(private httpClient: HttpClient) { }

  getSchoolProgramSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.SCHOOL_REPORT_PROGRAM_SUMMARY, payload);
  }

  getStudentBehavioralChangeSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.STUDENT_BEHAVIORAL_CHANGE_SUMMARY, payload);
  }

  getStudentFeedbackSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.STUDENT_FEEDBACK_SUMMARY, payload);
  }

  getTeacherFeedbackSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.TEACHER_FEEDBACK_SUMMARY, payload);
  }

  getIndividualMentoringSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.INDIVIDUAL_MENTORING_SUMMARY, payload);
  }

  getSmallGroupSupportSummary(payload: any): Observable<any> {
    return this.httpClient.post(API.SMALL_GROUP_SUPPORT_SUMMARY, payload);
  }

  getActivitySummary(payload: any): Observable<any> {
    return this.httpClient.post(API.ACTIVITY_SUMMARY, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/school_report.service.ts